declare global {
    // tslint:disable-next-line: interface-name
    interface Window {
        google: typeof google;
    }
}

export class MapScripts {
    public static GoogleScriptsLoaded = false;

    public static EnsureScripts(scriptsPath: string, callback: () => void, callBackError: (error: any) => void) {
        if (MapScripts.GoogleScriptsLoaded === true || (window.google && window.google.maps)) {
            if (callback) {
                callback();
            }
            return;
        }

        if (!scriptsPath) {
            return;
        }

        if (callback) {
            MapScripts.callStack.push(callback);
        }

        if (callBackError) {
            MapScripts.errorStack.push(callBackError);
        }

        if (MapScripts.waiting === true) {
            return;
        }

        MapScripts.waiting = true;

        const success = () => {
            MapScripts.GoogleScriptsLoaded = true;
            MapScripts.waiting = false;

            while (MapScripts.callStack.length > 0) {
                const fn = MapScripts.callStack.shift();
                if (fn) {
                    fn();
                }
            }
        }

        const error = (e: any) => {
            MapScripts.waiting = false;

            while (MapScripts.errorStack.length > 0) {
                const fn = MapScripts.errorStack.shift();
                if (fn) {
                    fn(e);
                }
            }
        }

        const jsScript = document.createElement("script");
        jsScript.setAttribute("src", scriptsPath);
        jsScript.setAttribute("type", "text/javascript");
        jsScript.onload = success;
        jsScript.onerror = error;
        jsScript.async = true;
        jsScript.defer = true;

        document.body.appendChild(jsScript);
    }

    private static waiting = false;

    private static callStack: Array<(() => void)> = [];

    private static errorStack: Array<((error: any) => void)> = [];

}